import * as React from 'react';
import Spinner from './Spinner';

export interface LoaderProps {
    colorclassname?: string;
    isFixed?: boolean;
    isInline?: boolean;
}

/**
 * Relative to current area or fix to whole screen
 * Relative to current area will not have Portal Feature. Need to work on it
 *
 * @param {string} colorclassname
 * @param {boolean} isFixed - is relative to current area or fixed to screen
 * @param {boolean} isInline - is relative to parent or inline. Only use this when isFixed is false
 */
const Loader = (props: LoaderProps) => {
    const { colorclassname, isInline } = props;

    if (isInline) {
        return (
            <div className="loader">
                <Spinner className={colorclassname} />
            </div>
        );
    } else {
        return (
            <div
                className="page-loader"
                style={{
                    height: '100%',
                    width: '100%',
                    background: 'rgba(0,0,0,0.1)'
                }}
            >
                <Spinner className={colorclassname} />
            </div>
        );
    }
};

export default Loader;

/**
 *
 * Backdrop for the spinner
 * Relative when backdrop is relative to specific area only
 * Fix when backdrop cover all the area of the screen
 * @param {boolean} isOpen - Open Backdrop. Part of props
 * @param {boolean} isAbsolute -  Relative to area or fix to the screen
 *
 */
